import { useEffect, useMemo } from 'react'
import { createSyncWorker, type SyncWorker } from './syncWorker'

/** Mounts the one device-wide drain loop; screens only write to Dexie. */
export function useOutboxSync(isOnline: boolean, isAuthenticated: boolean): void {
  const worker = useMemo<SyncWorker>(() => createSyncWorker(), [])

  useEffect(() => {
    worker.start({ isOnline, isAuthenticated })

    return () => worker.stop()
  }, [isAuthenticated, isOnline, worker])
}
